import React from 'react';
import { Users } from 'lucide-react';
import { useVisitorCount } from '../../hooks/useVisitorCount';

export const HeroSection = () => {
  const counts = useVisitorCount();
  return (
    <section className="bg-gradient-to-t from-cyan-100 to-blue-600 min-h-[90vh] flex items-center">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          {/* Content Section */}
          <div className="lg:w-1/2 w-full space-y-6 text-center lg:text-left">
            <div>
              <span className="inline-block bg-red-600 text-white text-xs sm:text-sm font-semibold px-3 py-1 rounded-md">
                TAX CONSULTING
              </span>
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[50px] font-bold leading-tight">
              We Make Tax Filing Feel Like A Breeze
            </h1>
            
            <p className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800">
              Save money and time through our tax planning strategies
            </p>
            
            <p className="text-sm sm:text-base font-medium">
              Fast, reliable and stress free tax return filing
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4 justify-center lg:justify-start">
              <button className="bg-white text-blue-600 hover:bg-blue-50 px-6 py-3 rounded-lg font-semibold shadow-md transition-colors">
                Get Started
              </button>
              <button className="bg-cyan-700 text-white hover:bg-blue-800 px-6 py-3 rounded-lg font-semibold shadow-md transition-colors">
                Learn More
              </button>
            </div>
          </div>
          
          {/* Image Section */}
          <div className="lg:w-1/2 w-full flex justify-center">
            <div className="relative w-full max-w-lg">
              <div className="absolute inset-0 bg-[url('https://thetaxbooks.com/wp-content/uploads/2022/08/finconsult-img2.png')] bg-contain bg-no-repeat bg-center opacity-30 -z-10"></div>
              <img 
                className="w-full h-auto object-contain animate-float"
                src="https://thetaxbooks.com/wp-content/uploads/2023/06/finconsult-img34.webp" 
                alt="Tax consulting illustration"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        {/* Visitor Stats at the bottom of the container */}
        {!counts.loading && counts.total > 0 && (
          <div className="mt-20 flex justify-center border-t border-black/5 pt-8">
            <div className="flex items-center gap-2 bg-blue-600/5 hover:bg-blue-600/10 border border-blue-600/10 px-6 py-2 rounded-full transition-all group">
              <Users size={16} className="text-blue-600 opacity-60 group-hover:opacity-100" />
              <span className="text-xs font-bold text-gray-500 uppercase tracking-[0.2em] group-hover:text-blue-700 italic">Total Users: <span className="font-mono text-sm ml-1 not-italic text-blue-900">{counts.total}</span></span>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};